package com.raouf.mehrguard.web.i18n

internal val ItalianStrings = mapOf(
    WebStringKey.AppName to "Mehr Guard",
    WebStringKey.AppTagline to "Rilevatore QRishing Kotlin Multiplatform",
    WebStringKey.MenuMain to "Menu Principale",
    WebStringKey.MenuSecurity to "Sicurezza",
    WebStringKey.MenuSystem to "Sistema",
    WebStringKey.NavDashboard to "Dashboard",
    WebStringKey.NavScanMonitor to "Monitor Scansione",
    WebStringKey.NavScanHistory to "Cronologia Scansioni",
    WebStringKey.NavTrustCentre to "Centro Fiducia",
    WebStringKey.NavReports to "Report",
    WebStringKey.NavTraining to "Formazione",
    WebStringKey.NavSettings to "Impostazioni",
    WebStringKey.QuickActions to "Azioni Rapide",

    // Hero Section
    WebStringKey.HeroTagline to "Sicuro. Offline.",
    WebStringKey.HeroTagline2 to "Difesa Trasparente.",
    WebStringKey.HeroDescription to "Mehr Guard analizza le potenziali minacce direttamente sul tuo hardware. Goditi una protezione a latenza zero.",

    // Dashboard
    WebStringKey.StartScan to "Avvia Nuova Scansione",
    WebStringKey.ImportImage to "Importa Immagine",
    WebStringKey.ScanQrCode to "Scansiona Codice QR",
    WebStringKey.SystemHealth to "Stato del Sistema",
    WebStringKey.ThreatDatabase to "Database Minacce",
    WebStringKey.Current to "Attuale",
    WebStringKey.Active to "Attivo",
    WebStringKey.Threats to "Minacce",
    WebStringKey.SafeScans to "Scansioni Sicure",
    WebStringKey.EngineActive to "Motore Attivo",
    WebStringKey.EnterpriseProtection to "Protezione Aziendale Attiva",
    WebStringKey.SystemOptimal to "Sistema Ottimale",
    WebStringKey.EngineStatus to "Motore v2.4 • Aggiornato 2h fa",
    WebStringKey.ThreatsBlocked to "Minacce Bloccate",
    WebStringKey.AllSystemsOperational to "Tutti i sistemi operativi",

    // Dashboard Sections
    WebStringKey.SectionOverview to "Panoramica",
    WebStringKey.SectionSecurity to "Sicurezza",
    WebStringKey.SectionTraining to "Formazione",
    WebStringKey.SectionReports to "Report",
    WebStringKey.OfflineReady to "Pronto Offline",
    WebStringKey.OfflineDescription to "Database locale v2.4.1 attivo. Nessun dato lascia questo dispositivo.",

    // Trust Centre
    WebStringKey.TrustCentreTitle to "Centro Fiducia",
    WebStringKey.OfflineGuarantee to "Garanzia Offline Rigorosa",
    WebStringKey.OfflineGuaranteeDesc to "L'analisi di Mehr Guard viene eseguita interamente sul Neural Engine del tuo dispositivo. I dati URL non lasciano mai il tuo telefono.",
    WebStringKey.ThreatSensitivity to "Sensibilità Minacce",
    WebStringKey.ResetConfirm to "Questo ripristinerà tutte le impostazioni del Centro Fiducia ai valori predefiniti.",

    // Settings Quick Actions
    WebStringKey.ThreatMonitor to "Monitor Minacce",
    WebStringKey.ThreatMonitorDesc to "Visualizza minacce in tempo reale ed esegui audit di sicurezza",
    WebStringKey.TrustCentreDesc to "Impostazioni privacy e sensibilità minacce",
    WebStringKey.ExportReport to "Esporta Report",
    WebStringKey.ExportReportDesc to "Genera report di sicurezza PDF o JSON",

    // Dashboard Content
    WebStringKey.Analyze to "Analizza",
    WebStringKey.HeuristicEngine to "Motore Euristico",
    WebStringKey.HighPerformanceEngine to "Motore ad Alte Prestazioni",
    WebStringKey.RecentScans to "Scansioni Recenti",
    WebStringKey.ViewFullHistory to "Visualizza Cronologia Completa",
    WebStringKey.Status to "Stato",
    WebStringKey.Source to "Origine",
    WebStringKey.Details to "Dettagli",
    WebStringKey.Time to "Ora",
    WebStringKey.Version to "Versione",
    WebStringKey.LastUpdate to "Ultimo Aggiornamento",
    WebStringKey.Signatures to "Firme",
    WebStringKey.CheckForUpdates to "Controlla Aggiornamenti",
    WebStringKey.FeatureOfflineTitle to "Architettura Offline-First",
    WebStringKey.FeatureOfflineDesc to "L'analisi completa viene eseguita localmente. I dati della fotocamera e i dati scansionati non toccano mai un server esterno, garantendo privacy assoluta.",
    WebStringKey.FeatureExplainableTitle to "Sicurezza Spiegabile",
    WebStringKey.FeatureExplainableDesc to "Non ricevere solo un \"Blocco\". Forniamo analisi euristiche dettagliate di parametri URL, reindirizzamenti e payload JavaScript.",
    WebStringKey.FeaturePerformanceDesc to "Ottimizzato per ambienti desktop. Le scansioni vengono elaborate in meno di 5ms utilizzando binari nativi Kotlin Multiplatform.",
    WebStringKey.TrainingCentre to "Centro Formazione",
    WebStringKey.LearnHomograph to "Impara a identificare attacchi omografi QR avanzati.",
    WebStringKey.BeatTheBotAction to "Batti il Bot →",
    WebStringKey.NoScansYet to "Nessuna scansione ancora. Avvia una nuova scansione per vedere i risultati qui.",
    WebStringKey.VerdictSafe to "SICURO",
    WebStringKey.VerdictPhish to "PHISHING",
    WebStringKey.VerdictWarn to "ATTENZIONE",
    WebStringKey.ScoreLabel to "Punteggio:",

    // Scanner
    WebStringKey.ActiveScanner to "Scanner Attivo",
    WebStringKey.OfflineMode to "Modalità Offline",
    WebStringKey.LiveFeedDisconnected to "FEED LIVE DISCONNESSO",
    WebStringKey.CameraAccessRequired to "Accesso Fotocamera Richiesto",
    WebStringKey.CameraAccessDescription to "Trascina e rilascia un'immagine con codice QR qui o abilita l'accesso alla fotocamera per iniziare la scansione.",
    WebStringKey.EnableCamera to "Abilita Fotocamera",
    WebStringKey.Scanning to "Scansione...",
    WebStringKey.ScanHint to "Mantieni fermo. Analizzato offline in <5ms.",
    WebStringKey.Torch to "Torcia",
    WebStringKey.Gallery to "Galleria",
    WebStringKey.PasteUrl to "Incolla URL",
    WebStringKey.PasteUrlTitle to "Incolla URL da Analizzare",
    WebStringKey.AnalyzeUrl to "Analizza URL",
    WebStringKey.SystemStatus to "Stato Sistema",
    WebStringKey.PhishingEngine to "Motore Phishing",
    WebStringKey.Ready to "PRONTO",
    WebStringKey.LocalDb to "DB Locale",
    WebStringKey.Latency to "Latenza",
    WebStringKey.ViewAll to "Visualizza Tutto",

    // Threat / Results
    WebStringKey.BreadcrumbHome to "Inizio",
    WebStringKey.BreadcrumbScans to "Scansioni",
    WebStringKey.OfflineProtection to "Protezione Offline",
    WebStringKey.VerdictHighRisk to "ALTO RISCHIO RILEVATO",
    WebStringKey.VerdictDangerous to "Pericoloso",
    WebStringKey.VerdictDangerousDesc to "Il codice QR scansionato contiene indicatori malevoli associati a phishing e raccolta credenziali. Non procedere all'URL target.",
    WebStringKey.ThreatConfidence to "Confidenza Minaccia",
    WebStringKey.FlagPhishing to "Tentativo di Phishing",
    WebStringKey.FlagObfuscated to "Script Offuscato",
    WebStringKey.FlagHomograph to "Attacco Omografo",
    WebStringKey.ClearHistory to "Cancella Tutto",
    WebStringKey.SectionAttackBreakdown to "Analisi Attacco",
    WebStringKey.AttackHomographTitle to "Attacco Omografo / IDN",
    WebStringKey.AttackHomographDesc to "Rilevati caratteri cirillici che imitano l'alfabeto latino.",
    WebStringKey.AttackVisualLabel to "Aspetto Visivo",
    WebStringKey.AttackPunycodeLabel to "Punycode Effettivo",
    WebStringKey.AttackHomographExplain to "Il dominio usa il cirillico 'а' (U+0430) invece del latino 'a' (U+0061). Questa tecnica è comunemente usata per ingannare gli utenti facendogli credere di visitare un servizio legittimo.",
    WebStringKey.AttackRedirectTitle to "Catena di Redirect Sospetta",
    WebStringKey.AttackRedirectDesc to "Rilevati 3 hop che coinvolgono abbreviatori URL noti.",
    WebStringKey.RedirectStart to "Scansione Codice QR",
    WebStringKey.RedirectHop to "Hop Intermedio",
    WebStringKey.RedirectFinal to "Destinazione Finale",
    WebStringKey.AttackJsTitle to "JavaScript Offuscato",
    WebStringKey.AttackJsDesc to "Rilevata stringa ad alta entropia nei parametri URL.",
    WebStringKey.SectionActions to "Azioni Raccomandate",
    WebStringKey.ActionBlock to "Blocca e Segnala",
    WebStringKey.ActionBlockDesc to "Impedisci l'accesso e notifica l'amministratore",
    WebStringKey.ActionQuarantine to "Quarantena in Sandbox",
    WebStringKey.ActionQuarantineDesc to "Apri in sicurezza per l'analisi",
    WebStringKey.Expected to "Previsto: ",
    WebStringKey.Detected to "Rilevato: ",
    WebStringKey.ExplainableSecurity to "Sicurezza Spiegabile",
    WebStringKey.UrlBreakdown to "ANALISI URL",
    WebStringKey.FullUrl to "URL COMPLETO",
    WebStringKey.OpenInBrowser to "Apri nel Browser (Rischioso)",
    WebStringKey.OpenWarning to "Aprire questo URL nel browser potrebbe esporti a rischi di sicurezza.",
    WebStringKey.RestrictedMode to "Modalità Ristretta",
    WebStringKey.RestrictedDesc to "Questo URL è stato segnalato come potenzialmente pericoloso. Esamina l'analisi sottostante prima di procedere.",
    WebStringKey.DangerousWarning to "Questo URL è stato segnalato come potenzialmente pericoloso. Aprirlo potrebbe esporti a phishing, malware o altre minacce alla sicurezza. Sei sicuro di voler procedere?",
    WebStringKey.CopyUrl to "Copia URL",
    WebStringKey.Share to "Condividi",
    WebStringKey.Dismiss to "Chiudi",
    WebStringKey.ReasonDomainAge to "L'età del dominio è inferiore a 24 ore.",
    WebStringKey.ReasonSignatures to "Corrispondenza con 3 firme nel DB phishing locale.",
    WebStringKey.ReasonAsn to "L'IP target si trova in un ASN ad alto rischio.",
    WebStringKey.SectionMeta to "Meta Scansione",
    WebStringKey.MetaTime to "Ora Scansione",
    WebStringKey.MetaSource to "Origine",
    WebStringKey.MetaEngine to "Motore",
    WebStringKey.MetaOfflineGuaranteeLabel to "Garanzia Offline:",
    WebStringKey.MetaOfflineGuaranteeDesc to "Questa immagine è stata analizzata localmente sul tuo dispositivo. Nessun dato è stato inviato al cloud per questo verdetto.",
    
    // Results Page
    WebStringKey.ScanComplete to "Scansione Completa",
    WebStringKey.Loading to "Caricamento...",
    WebStringKey.AnalyzedOffline to "Analizzato offline in <5ms",
    WebStringKey.NoDataLeaves to "Nessun dato lascia il dispositivo",
    WebStringKey.ActiveProtection to "Protezione Attiva",
    WebStringKey.ConfidenceScore to "Punteggio Confidenza",
    WebStringKey.Analyzing to "ANALISI IN CORSO...",
    WebStringKey.ProcessingResults to "Elaborazione risultati scansione...",
    WebStringKey.RiskAssessment to "Valutazione Rischio",
    WebStringKey.AnalysisTime to "Tempo di Analisi",
    WebStringKey.Heuristics to "Euristiche",
    WebStringKey.TopAnalysisFactors to "Principali Fattori di Analisi",
    WebStringKey.Pass to "SUPERATO",
    WebStringKey.Info to "INFO",
    WebStringKey.Clean to "PULITO",
    WebStringKey.ValidSslCertificate to "Certificato SSL Valido",
    WebStringKey.SslCertificateDesc to "Certificato emesso da DigiCert Inc. Nessuna anomalia nella catena di fiducia.",
    WebStringKey.EstablishedDomain to "Dominio Consolidato",
    WebStringKey.EstablishedDomainDesc to "Dominio registrato da > 5 anni. Bassa probabilità di frode.",
    WebStringKey.BlacklistStatus to "Stato Lista Nera",
    WebStringKey.BlacklistStatusDesc to "Non trovato in 52 database minacce locali.",
    WebStringKey.BackToDashboard to "Torna alla Dashboard",
    WebStringKey.ShareReport to "Condividi Report",
    WebStringKey.CopyLink to "Copia Link",
    WebStringKey.LinkCopied to "Link copiato negli appunti!",
    
    // Game Page
    WebStringKey.BeatTheBot to "Batti il Bot",
    WebStringKey.BeatTheBotDesc to "Sfida la nostra IA offline. Riesci a rilevare il phishing più velocemente?",
    WebStringKey.SessionId to "ID Sessione",
    WebStringKey.EndSession to "Termina Sessione",
    WebStringKey.Round to "Turno",
    WebStringKey.BrowserPreview to "Anteprima Browser",
    WebStringKey.MakeDecision to "Prendi la tua decisione",
    WebStringKey.Phishing to "Truffa",
    WebStringKey.Legitimate to "Legittimo",
    WebStringKey.LiveHint to "Suggerimento Live",
    WebStringKey.LiveScoreboard to "Classifica Live",
    WebStringKey.VsMode to "MODALITÀ VS",
    WebStringKey.You to "Tu",
    WebStringKey.Points to "pt",
    WebStringKey.Streak to "Serie",
    WebStringKey.Accuracy to "Precisione",
    WebStringKey.MehrGuardBot to "Bot Mehr Guard",
    WebStringKey.Confidence to "Confidenza",
    WebStringKey.RoundAnalysis to "Analisi Round",
    WebStringKey.Analysis to "Analisi",
    WebStringKey.CorrectDecision to "Decisione Corretta!",
    WebStringKey.IdentifiedSafe to "Hai identificato correttamente l'URL sicuro.",
    WebStringKey.AiNeuralAnalysis to "Analisi Neurale IA",
    WebStringKey.WhyBotFlagged to "Perché il bot l'ha segnalato",
    WebStringKey.EducationalNote to "Nota Educativa",
    WebStringKey.Correct to "Corretto!",
    WebStringKey.SpottedPhishing to "Hai rilevato correttamente l'URL di phishing.",
    WebStringKey.Response to "Risposta",
    WebStringKey.NextRound to "Round Successivo",
    WebStringKey.GameOver to "Fine Partita!",
    WebStringKey.FinalResults to "Risultati Finali",
    WebStringKey.YourScore to "Il Tuo Punteggio",
    WebStringKey.BotScore to "Punteggio Bot",
    WebStringKey.BestStreak to "Migliore Serie",
    WebStringKey.PlayAgain to "Gioca Ancora",
    WebStringKey.ReturnToDashboard to "Torna alla Dashboard",
    
    // Export Page
    WebStringKey.ExportSecurityReport to "Esporta Report Sicurezza",
    WebStringKey.GenerateReport to "Genera report di sicurezza completi dalla tua cronologia scansioni.",
    WebStringKey.ReportFormat to "Formato Report",
    WebStringKey.HumanReadable to "Report Leggibile",
    WebStringKey.HumanReadableDesc to "PDF con analisi visiva e sommario esecutivo",
    WebStringKey.MachineReadable to "Dati Macchina",
    WebStringKey.MachineReadableDesc to "Formato JSON per integrazione SIEM",
    WebStringKey.DateRange to "Intervallo Date",
    WebStringKey.Last7Days to "Ultimi 7 Giorni",
    WebStringKey.Last30Days to "Ultimi 30 Giorni",
    WebStringKey.Last90Days to "Ultimi 90 Giorni",
    WebStringKey.AllTime to "Tutto il Tempo",
    WebStringKey.CustomRange to "Intervallo Personalizzato",
    WebStringKey.ReportSections to "Sezioni Report",
    WebStringKey.ExecutiveSummary to "Sommario Esecutivo",
    WebStringKey.ThreatBreakdown to "Analisi Minacce",
    WebStringKey.ScanTimeline to "Cronologia Scansioni",
    WebStringKey.SafeUrlList to "Lista URL Sicuri",
    WebStringKey.GenerateExport to "Esporta Report",
    
    // Toast / Notifications
    WebStringKey.Success to "Successo!",
    WebStringKey.Error to "Errore",
    WebStringKey.Warning to "Avviso",
    WebStringKey.CopiedToClipboard to "Copiato negli appunti",
    
    // General Actions
    WebStringKey.Cancel to "Annulla",
    WebStringKey.Confirm to "Conferma",
    WebStringKey.Save to "Salva",
    WebStringKey.Delete to "Elimina",
    WebStringKey.Edit to "Modifica",
    WebStringKey.Close to "Chiudi",
    WebStringKey.Back to "Indietro",
    WebStringKey.Next to "Avanti",
    WebStringKey.Previous to "Precedente",
    WebStringKey.Submit to "Invia",
    WebStringKey.Reset to "Reimposta",
    WebStringKey.Clear to "Cancella",
    WebStringKey.Search to "Cerca",
    WebStringKey.Filter to "Filtra",
    WebStringKey.Sort to "Ordina",
    
    // Accessibility
    WebStringKey.ToggleMenu to "Attiva/Disattiva menu",
    WebStringKey.ToggleTheme to "Attiva/Disattiva tema",
    WebStringKey.Notifications to "Notifiche",
    WebStringKey.Help to "Aiuto",
    WebStringKey.Profile to "Profilo",
    WebStringKey.ToggleLightDarkMode to "Attiva/Disattiva modalità chiaro/scuro",
    
    // Placeholders
    WebStringKey.UrlInputPlaceholder to "Incolla URL da analizzare (es: https://example.com)",
    WebStringKey.UrlExamplePlaceholder to "https://example.com",
    
    // Export Page Additional
    WebStringKey.Scan to "Scansione",
    WebStringKey.Result to "Risultato",
    WebStringKey.ReportGeneration to "Generazione Report",
    WebStringKey.ReportGenerationDesc to "Configura i formati e scarica la tua analisi delle minacce.",
    WebStringKey.OfflineSecurity to "Sicurezza Offline",
    WebStringKey.OfflineSecurityDesc to "I tuoi dati non lasciano mai questo dispositivo. Tutta l'elaborazione è locale.",
    WebStringKey.ChooseFormat to "Scegli Formato",
    WebStringKey.PdfFormatDesc to "Formato PDF. Ideale per la condivisione.",
    WebStringKey.JsonFormatDesc to "Formato JSON. Ideale per integrazione SIEM.",
    WebStringKey.Copy to "Copia",
    WebStringKey.LivePreview to "Anteprima Live",
    WebStringKey.ReadOnly to "Sola Lettura",
    WebStringKey.ThreatAnalysisReport to "Report Analisi Minacce",
    WebStringKey.Verdict to "Verdetto",
    WebStringKey.RiskScore to "Punteggio Rischio",
    WebStringKey.TargetUrl to "URL Target",
    WebStringKey.AnalysisSummaryLabel to "Riepilogo Analisi",
    WebStringKey.TechnicalIndicators to "Indicatori Tecnici",
    WebStringKey.ExportInfoNote to "Le esportazioni includono tutti i vettori di minaccia identificati e l'analisi del payload.",
    
    // Trust Centre Page
    WebStringKey.AllowList to "Lista Consentiti",
    WebStringKey.BlockList to "Lista Bloccati",
    WebStringKey.AddDomain to "Aggiungi Dominio",
    WebStringKey.RemoveDomain to "Rimuovi Dominio",
    WebStringKey.TrustedDomains to "Domini Affidabili",
    WebStringKey.BlockedDomains to "Domini Bloccati",
    WebStringKey.DomainPlaceholder to "Inserisci dominio (es: example.com)",
    
    // Game Page Additional
    WebStringKey.Safe to "Sicuro",
    WebStringKey.TimeAgo to "fa",
    WebStringKey.MinutesAgo to "min fa",
    WebStringKey.HoursAgo to "ore fa",
    
    // Misc
    WebStringKey.Critical to "CRITICO",
    WebStringKey.Warn to "AVVISO",
    
    // Trust Centre - Sensitivity
    WebStringKey.PhishingDetectionSensitivity to "Sensibilità Rilevamento Phishing",
    WebStringKey.SensitivityDescription to "Regola le soglie euristiche. Una sensibilità maggiore può aumentare i falsi positivi.",
    WebStringKey.SensitivityLow to "Basso",
    WebStringKey.SensitivityBalanced to "Bilanciato",
    WebStringKey.SensitivityParanoia to "Massima",
    WebStringKey.BalancedModeRecommended to "Modalità Bilanciata (Consigliata)",
    WebStringKey.BalancedModeDesc to "Cerca pattern malevoli noti e incongruenze euristiche. Blocca attacchi omoglifi e catene di redirect.",
    WebStringKey.LowSensitivityMode to "Modalità Sensibilità Bassa",
    WebStringKey.LowSensitivityModeDesc to "Blocca solo URL malevoli noti dal database delle minacce. Minimi falsi positivi, ma potrebbe perdere nuovi attacchi.",
    WebStringKey.ParanoiaMode to "Modalità Paranoia",
    WebStringKey.ParanoiaModeDesc to "Protezione massima. Blocca qualsiasi pattern sospetto inclusi domini appena registrati, TLD non comuni e qualsiasi URL con potenziali trucchi di codifica.",
    WebStringKey.PrivacyGuaranteeDesc to "Mehr Guard utilizza motori di analisi euristica locali. Nessun dato immagine, stringa URL o metadati lascia questo dispositivo durante la scansione. La tua privacy è matematicamente garantita.",
    WebStringKey.SignalBrandImpersonation to "Rilevata potenziale impersonificazione del marchio",
    WebStringKey.SignalCredentialParams to "Parametri relativi alle credenziali nell'URL",
    WebStringKey.SignalEncodedPayload to "Dati codificati rilevati nei parametri della query",
    WebStringKey.SignalExcessiveSubdomains to "Profondità sottodominio eccessiva ({count} livelli)",
    WebStringKey.SignalHighEntropyHost to "Alta casualità nel nome di dominio",
    WebStringKey.SignalHomographAttack to "Il dominio contiene caratteri omografi/confondibili",
    WebStringKey.SignalHttpNotHttps to "Usa protocollo HTTP non sicuro",
    WebStringKey.SignalIpAddressHost to "L'host è un indirizzo IP invece di un dominio",
    WebStringKey.SignalLongUrl to "URL insolitamente lungo ({length} caratteri)",
    WebStringKey.SignalLongUrlMarketing to "URL insolitamente lungo ({length} caratteri) - contiene parametri di marketing",
    WebStringKey.SignalNewlyRegisteredDomain to "Rilevato dominio appena registrato",
    WebStringKey.SignalNonStandardPort to "Porta non standard: {port}",
    WebStringKey.SignalNumericSubdomain to "Rilevato sottodominio solo numerico",
    WebStringKey.SignalSuspiciousPathKeywords to "Parole chiave sospette nel percorso ({count} trovate)",
    WebStringKey.SignalSuspiciousTld to "TLD sospetto: {tld}",
    WebStringKey.SignalUrlShortener to "Usa servizio di accorciamento URL",
    WebStringKey.SecureEnvironment to "Ambiente Sicuro",
    WebStringKey.LearnLocalArchitecture to "Scopri la nostra architettura locale",
    WebStringKey.NoCustomDomainsBlocked to "Nessun dominio personalizzato bloccato.",
    WebStringKey.AddManually to "Aggiungi manualmente",
    WebStringKey.AddedDaysAgo to "Aggiunto 2 giorni fa",
    WebStringKey.AddedWeekAgo to "Aggiunto 1 settimana fa",
    
    // Trust Centre - Privacy Controls
    WebStringKey.PrivacyControls to "Controlli Privacy",
    WebStringKey.StrictOfflineMode to "Modalità Offline Rigorosa",
    WebStringKey.DisableExternalPreviews to "Disabilita tutte le anteprime link esterni.",
    WebStringKey.AnonymousTelemetry to "Telemetria Anonima",
    WebStringKey.ShareDetectionStats to "Condividi statistiche rilevamento per migliorare ML.",
    WebStringKey.AutoCopySafeLinks to "Copia Automatica Link Sicuri",
    WebStringKey.CopyTrustedUrls to "Copia URL affidabili negli appunti.",
    
    // Trust Centre - About
    WebStringKey.AboutMehrGuard to "Informazioni su Mehr Guard",
    WebStringKey.OpenSourceLicenses to "Licenze Open Source",
    WebStringKey.PrivacyPolicy to "Informativa sulla Privacy",
    WebStringKey.Acknowledgements to "Ringraziamenti",
    WebStringKey.ResetAllSettings to "Reimposta tutte le impostazioni",
    WebStringKey.AddToAllowlist to "Aggiungi alla Lista Consentiti",
    WebStringKey.AddToBlocklist to "Aggiungi alla Lista Bloccati",
    
    // Onboarding
    WebStringKey.AnalysedOfflineTitle to "Analizzato offline.",
    WebStringKey.YourDataStaysOnDevice to "I tuoi dati restano sul dispositivo.",
    WebStringKey.OnboardingHeroDesc to "Mehr Guard elabora ogni scansione con analisi sicura sul dispositivo. Diamo priorità alla sicurezza spiegabile senza telemetria cloud.",
    WebStringKey.OnDeviceAnalysis to "Analisi sul Dispositivo",
    WebStringKey.OnDeviceAnalysisDesc to "Tutto il rilevamento minacce viene eseguito localmente sul tuo dispositivo. Nessun dato lascia il tuo sistema.",
    WebStringKey.NoCloudLogs to "Nessun Log Cloud",
    WebStringKey.NoCloudLogsDesc to "Disabilitiamo rigorosamente la telemetria in uscita per le scansioni. I risultati e gli hash restano locali.",
    WebStringKey.OnDeviceDB to "Database sul Dispositivo",
    WebStringKey.OnDeviceDBDesc to "L'intero database delle firme minacce viene scaricato sul tuo dispositivo per ricerche in millisecondi.",
    WebStringKey.DataLifecycleVerification to "Verifica Ciclo di Vita Dati",
    WebStringKey.SecurityAuditPass to "Audit Sicurezza: SUPERATO",
    
    // Footer
    WebStringKey.Copyright to "© 2025-2026 Mehr Guard Security Inc. Tutti i diritti riservati.",
    WebStringKey.Support to "Supporto",
    WebStringKey.Terms to "Termini",
    WebStringKey.SystemsOperational to "Sistemi Operativi",
    WebStringKey.SystemSecure to "Sistema Sicuro",
    
    // Version / Build Info
    WebStringKey.VersionStatus to "v2.4.1 • Sistema Sicuro",
    WebStringKey.CoreVersion to "Core v2.4.1 • Build 2024.12.19",
    WebStringKey.VerifiedBy to "Verificato da Mehr Guard Enterprise",
    
    // User Profile (Sample)
    WebStringKey.SampleUserName to "Mario Rossi",
    WebStringKey.SampleUserRole to "Analista Sicurezza",
    
    // Export Preview
    WebStringKey.DetailLabel to "Etichetta Dettaglio",
    WebStringKey.DetailValue to "Valore Dettaglio",
    WebStringKey.Suspicious to "Sospetto",
    
    // Game Modal Strings
    WebStringKey.IncorrectDecision to "Decisione Errata",
    WebStringKey.WrongAnswer to "Ops! Non era corretto.",
    WebStringKey.ResponseTime to "Tempo di Risposta",
    WebStringKey.IncomingMessage to "Messaggio in Arrivo",
    WebStringKey.CertificateIssuer to "L'emittente del certificato corrisponde al proprietario del dominio",
    WebStringKey.DomainAgeTrust to "Età dominio > 5 anni (Alta fiducia)",
    WebStringKey.WhitelistedRank to "Top 1k Alexa in lista bianca locale",
    
    // Game Tips/Hints
    WebStringKey.GameEducationalNote to "Nota Educativa",
    WebStringKey.GameHintTitle to "Suggerimento Gioco",
    
    // Trust Modal
    WebStringKey.AddToAllowlistTitle to "Aggiungi alla Lista Consentiti",
    WebStringKey.AddToBlocklistTitle to "Aggiungi alla Lista Bloccati",
    WebStringKey.EnterDomainPrompt to "Inserisci un dominio da aggiungere alla tua lista",
    
    // Additional Game Strings
    WebStringKey.LatencyMs to "Latenza",
    WebStringKey.StreakFire to "Serie",
    WebStringKey.AccuracyPercent to "Precisione",
    WebStringKey.ConfidencePercent to "Confidenza",
    
    // Languages
    WebStringKey.English to "Inglese",
    WebStringKey.German to "Tedesco",
    WebStringKey.Spanish to "Spagnolo",
    WebStringKey.French to "Francese",
    WebStringKey.ChineseSimplified to "Cinese (Semplificato)",
    WebStringKey.Japanese to "Giapponese",
    WebStringKey.Hindi to "Indiano",
    WebStringKey.Arabic to "Arabo",
    WebStringKey.Indonesian to "Indonesiano",
    WebStringKey.Italian to "Italiano",
    WebStringKey.Korean to "Coreano",
    WebStringKey.Portuguese to "Portoghese",
    WebStringKey.Russian to "Russo",
    WebStringKey.Thai to "Tailandese",
    WebStringKey.Turkish to "Turco",
    WebStringKey.Vietnamese to "Vietnamita"
,
    WebStringKey.ComponentVoting to "Votazione Componenti",
    WebStringKey.Heuristic to "Euristica",
    WebStringKey.MLModel to "Modello ML",
    WebStringKey.Brand to "Marchio",
    WebStringKey.TLD to "TLD",
    WebStringKey.VotingExplanation to "Il voto di maggioranza determina il verdetto: 3+ SICURO = verde, 2+ MALIGNO = rosso"
,
    // Results Page Placeholders,
    WebStringKey.WaitingForScan to "In attesa di scansione...",
    WebStringKey.WaitingForAnalysis to "In attesa di analisi...",
    WebStringKey.ScanURLToSeeResults to "Scansiona un URL per vedere i risultati dettagliati.",

    // Keyboard Shortcuts & Settings
    WebStringKey.KeyboardShortcuts to "Scorciatoie da Tastiera",
    WebStringKey.StartScanner to "Avvia Scanner",
    WebStringKey.CloseMenuModal to "Chiudi Menu / Modale",
    WebStringKey.NavigateToDashboard to "Vai alla Dashboard",
    WebStringKey.NavigateToHistory to "Cronologia Scansioni",
    WebStringKey.NavigateToTrust to "Centro Fiducia / Lista Consentiti",
    WebStringKey.NavigateToGame to "Gioco Batti il Bot",
    WebStringKey.ShowHelp to "Mostra Aiuto",
    WebStringKey.GotIt to "Capito",
    WebStringKey.SecuritySettings to "Impostazioni di Sicurezza",
    WebStringKey.SensitivityLevel to "Livello di Sensibilità",
    WebStringKey.AutoBlockThreats to "Blocca Minacce Automaticamente",
    WebStringKey.RealTimeScanning to "Scansione in Tempo Reale",
    WebStringKey.SoundAlerts to "Avvisi Sonori",
    WebStringKey.ThreatAlerts to "Avvisi di Minacce",
    WebStringKey.ShowConfidenceScore to "Mostra Punteggio di Confidenza",
    WebStringKey.CompactView to "Vista Compatta",
    WebStringKey.ResetDefaults to "Ripristina Predefiniti",
    WebStringKey.SaveAndContinue to "Salva e Continua",

    // Missing Keys - Security Signals & Results
    WebStringKey.AboutDescription to "Informazioni su Mehr Guard Security",
    WebStringKey.ActualDomain to "Dominio Effettivo",
    WebStringKey.AnalysisComplete to "Analisi Completata",
    WebStringKey.AutoBlockThreatsDesc to "Blocca automaticamente le minacce",
    WebStringKey.AwaitingScanLabel to "In Attesa di Scansione",
    WebStringKey.BrandImpersonation to "Impersonificazione del Marchio",
    WebStringKey.CautionAdvised to "Si Consiglia Cautela",
    WebStringKey.CompactViewDesc to "Vista Compatta",
    WebStringKey.DoNotVisit to "NON VISITARE",
    WebStringKey.DoNotVisitDesc to "Phishing ad alta affidabilità rilevato. Questo URL mostra molteplici indicatori malevoli.",
    WebStringKey.DomainUsesInternationalChars to "Questo dominio utilizza caratteri internazionali che potrebbero imitare domini legittimi.",
    WebStringKey.GoToScanner to "Vai allo Scanner",
    WebStringKey.Hebrew to "Ebraico",
    WebStringKey.HelpKeyboardShortcuts to "Scorciatoie da Tastiera",
    WebStringKey.HeuristicAnalysis to "Analisi Euristica",
    WebStringKey.HeuristicAnalysisDesc to "URL contrassegnato in base a molteplici fattori di rischio rilevati dal motore di analisi.",
    WebStringKey.HiddenDestination to "Destinazione Nascosta",
    WebStringKey.HighRisk to "Alto Rischio",
    WebStringKey.HighRiskLabel to "ALTO RISCHIO",
    WebStringKey.HomographIdnAttack to "Attacco Omografo / IDN",
    WebStringKey.InternationalizedDomainDetected to "Nome di dominio internazionalizzato rilevato.",
    WebStringKey.JustNow to "Proprio ora",
    WebStringKey.KeyboardShortcutsDesc to "Scorciatoie da tastiera per accesso rapido",
    WebStringKey.LiveFeedActive to "FEED LIVE ATTIVO",
    WebStringKey.LowRisk to "Basso Rischio",
    WebStringKey.LowRiskLabel to "BASSO RISCHIO",
    WebStringKey.Malicious to "Malevolo",
    WebStringKey.MediumRiskLabel to "RISCHIO MEDIO",
    WebStringKey.NoData to "NESSUN DATO",
    WebStringKey.NoScanDataResults to "Nessun dato di scansione disponibile. Esegui la scansione di un URL per vedere i risultati dell'analisi.",
    WebStringKey.NoUrlScanned to "Nessun URL scansionato",
    WebStringKey.Persian to "Persiano",
    WebStringKey.PhishingIndicators to "Indicatori di Phishing",
    WebStringKey.ProceedWithCaution to "PROCEDERE CON CAUTELA",
    WebStringKey.ProceedWithCautionDesc to "Alcuni indicatori sospetti rilevati. Verifica la fonte prima di inserire informazioni sensibili.",
    WebStringKey.RealTimeScanningDesc to "Scansione in tempo reale",
    WebStringKey.RedirectShortenerDetected to "Reindirizzamento/Abbreviatore Rilevato",
    WebStringKey.SafeToVisit to "SICURO DA VISITARE",
    WebStringKey.SafeToVisitDesc to "Verificato dall'euristica locale v2.4. Nessun pattern di phishing, script offuscati o corrispondenze nella blacklist trovati.",
    WebStringKey.SafetyScore to "Punteggio di Sicurezza",
    WebStringKey.ScanCompleteLabel to "Scansione Completata",
    WebStringKey.ScanToAnalyze to "Scansiona un codice QR o inserisci un URL da analizzare.",
    WebStringKey.ScannedURLLabel to "URL Scansionato",
    WebStringKey.SecuritySignal to "Segnale di Sicurezza",
    WebStringKey.SensitivityLevelDesc to "Livello di Sensibilità",
    WebStringKey.SensitivityPermissive to "Permissivo",
    WebStringKey.SensitivityStrict to "Rigoroso",
    WebStringKey.SettingsDetection to "Rilevamento",
    WebStringKey.SettingsDisplay to "Visualizzazione",
    WebStringKey.SettingsLanguage to "Lingua",
    WebStringKey.SettingsLanguageDesc to "Seleziona la lingua dell'interfaccia",
    WebStringKey.SettingsNotifications to "Notifiche",
    WebStringKey.SettingsSavedAutomatically to "Le impostazioni vengono salvate automaticamente e sincronizzate tra le sessioni.",
    WebStringKey.ShowConfidenceScoreDesc to "Mostra punteggio di affidabilità",
    WebStringKey.SoundAlertsDesc to "Avvisi sonori",
    WebStringKey.SuspiciousDomain to "Dominio Sospetto",
    WebStringKey.SuspiciousEncoding to "Codifica Sospetta",
    WebStringKey.SuspiciousKeywords to "Parole Chiave Sospette",
    WebStringKey.SuspiciousTld to "TLD Sospetto",
    WebStringKey.SuspiciousTldDesc to "Il dominio utilizza {tld} TLD comunemente associato a siti malevoli.",
    WebStringKey.SuspiciousUrlParams to "Parametri URL Sospetti",
    WebStringKey.SuspiciousUrlParamsDesc to "L'URL contiene parametri complessi o potenzialmente offuscati.",
    WebStringKey.ThreatAlertsDesc to "Avvisi di minacce",
    WebStringKey.ThreatDetected to "Minaccia Rilevata",
    WebStringKey.UnableToDetermine to "Impossibile determinare il verdetto. Riprova.",
    WebStringKey.Unknown to "Sconosciuto",
    WebStringKey.UnknownURL to "URL Sconosciuto",
    WebStringKey.UrlShortenerDesc to "L'URL utilizza un servizio di abbreviazione che nasconde la destinazione finale.",
    WebStringKey.UrlShortenerDetected to "Abbreviatore URL Rilevato",
    WebStringKey.VersionOfflineReady to "Pronto offline",
    WebStringKey.VisualAppearance to "Aspetto Visivo",
    WebStringKey.WaitingForAnalysisLabel to "In attesa di analisi...",

    // Reason Code Titles and Descriptions (for i18n of attack analysis cards)
    // CRITICAL severity
    WebStringKey.ReasonJavascriptUrlTitle to "URL JavaScript",
    WebStringKey.ReasonJavascriptUrlDesc to "Schema URL JavaScript rilevato - esegue codice quando cliccato",
    WebStringKey.ReasonDataUriTitle to "Data URI",
    WebStringKey.ReasonDataUriDesc to "Schema Data URI rilevato - potrebbe contenere codice malevolo incorporato",
    WebStringKey.ReasonAtSymbolInjectionTitle to "Iniezione Simbolo @",
    WebStringKey.ReasonAtSymbolInjectionDesc to "L'URL contiene il simbolo @ indicando possibile tentativo di furto credenziali",
    // HIGH severity
    WebStringKey.ReasonHomographTitle to "Attacco Omografo",
    WebStringKey.ReasonHomographDesc to "Il nome di dominio internazionalizzato (IDN) potrebbe impersonare un altro dominio",
    WebStringKey.ReasonMixedScriptTitle to "Script Misto",
    WebStringKey.ReasonMixedScriptDesc to "L'hostname contiene caratteri da script multipli (possibile spoofing)",
    WebStringKey.ReasonLookalikeCharsTitle to "Caratteri Simili",
    WebStringKey.ReasonLookalikeCharsDesc to "Il dominio contiene caratteri Unicode che assomigliano a lettere ASCII",
    WebStringKey.ReasonZeroWidthCharsTitle to "Caratteri a Larghezza Zero",
    WebStringKey.ReasonZeroWidthCharsDesc to "Rilevati caratteri Unicode nascosti a larghezza zero (tentativo di offuscamento)",
    WebStringKey.ReasonIpHostTitle to "Host IP",
    WebStringKey.ReasonIpHostDesc to "L'URL usa un indirizzo IP invece del nome di dominio",
    WebStringKey.ReasonCredentialParamTitle to "Parametro Credenziali",
    WebStringKey.ReasonCredentialParamDesc to "L'URL contiene parametri relativi alle credenziali (password, token, ecc.)",
    WebStringKey.ReasonBrandImpersonationTitle to "Impersonificazione del Marchio",
    WebStringKey.ReasonBrandImpersonationDesc to "L'URL sembra impersonare un marchio noto",
    WebStringKey.ReasonBrandInSubdomainTitle to "Marchio nel Sottodominio",
    WebStringKey.ReasonBrandInSubdomainDesc to "Il nome del marchio appare nel sottodominio ma non nel dominio principale",
    WebStringKey.ReasonRiskyExtensionTitle to "Estensione Rischiosa",
    WebStringKey.ReasonRiskyExtensionDesc to "Il percorso contiene un'estensione file potenzialmente pericolosa",
    WebStringKey.ReasonDoubleExtensionTitle to "Doppia Estensione",
    WebStringKey.ReasonDoubleExtensionDesc to "Rilevata doppia estensione file (tattica malware comune)",
    WebStringKey.ReasonEncodedPayloadTitle to "Payload Codificato",
    WebStringKey.ReasonEncodedPayloadDesc to "Rilevati dati codificati di grandi dimensioni nei parametri URL",
    // MEDIUM severity
    WebStringKey.ReasonHttpNotHttpsTitle to "HTTP non HTTPS",
    WebStringKey.ReasonHttpNotHttpsDesc to "L'URL usa il protocollo HTTP non sicuro invece di HTTPS",
    WebStringKey.ReasonSuspiciousTldTitle to "TLD Sospetto",
    WebStringKey.ReasonSuspiciousTldDesc to "Il dominio di primo livello è frequentemente usato per phishing",
    WebStringKey.ReasonHighEntropyHostTitle to "Host ad Alta Entropia",
    WebStringKey.ReasonHighEntropyHostDesc to "Il nome di dominio sembra generato casualmente",
    WebStringKey.ReasonRedirectParamTitle to "Parametro di Reindirizzamento",
    WebStringKey.ReasonRedirectParamDesc to "L'URL contiene un parametro di reindirizzamento che potrebbe portare ad un altro sito",
    WebStringKey.ReasonDeepSubdomainTitle to "Sottodominio Profondo",
    WebStringKey.ReasonDeepSubdomainDesc to "Profondità eccessiva del sottodominio (potrebbe nascondere il dominio reale)",
    WebStringKey.ReasonMultiTldTitle to "TLD Multiplo",
    WebStringKey.ReasonMultiTldDesc to "Segmenti multipli simili a TLD nel nome di dominio",
    WebStringKey.ReasonNumericSubdomainTitle to "Sottodominio Numerico",
    WebStringKey.ReasonNumericSubdomainDesc to "Rilevato sottodominio solo numerico",
    WebStringKey.ReasonNonStandardPortTitle to "Porta Non Standard",
    WebStringKey.ReasonNonStandardPortDesc to "L'URL usa un numero di porta non standard",
    WebStringKey.ReasonSuspiciousPortTitle to "Porta Sospetta",
    WebStringKey.ReasonSuspiciousPortDesc to "L'URL usa una porta comunemente associata ad attacchi",
    WebStringKey.ReasonFragmentHidingTitle to "Occultamento Frammento",
    WebStringKey.ReasonFragmentHidingDesc to "Il frammento URL sembra nascondere contenuto aggiuntivo",
    WebStringKey.ReasonExcessiveEncodingTitle to "Codifica Eccessiva",
    WebStringKey.ReasonExcessiveEncodingDesc to "Rilevata codifica URL eccessiva (tentativo di offuscamento)",
    WebStringKey.ReasonDomainAgePatternTitle to "Pattern Età Dominio",
    WebStringKey.ReasonDomainAgePatternDesc to "Il nome di dominio corrisponde a pattern di domini auto-generati",
    // LOW severity
    WebStringKey.ReasonUrlShortenerTitle to "Abbreviatore URL",
    WebStringKey.ReasonUrlShortenerDesc to "L'URL usa un servizio di abbreviazione (nasconde la destinazione reale)",
    WebStringKey.ReasonSuspiciousPathTitle to "Percorso Sospetto",
    WebStringKey.ReasonSuspiciousPathDesc to "Il percorso contiene parole chiave sospette (login, verify, ecc.)",
    WebStringKey.ReasonLongUrlTitle to "URL Lungo",
    WebStringKey.ReasonLongUrlDesc to "URL insolitamente lungo",
    WebStringKey.ReasonCredentialKeywordsTitle to "Parole Chiave Credenziali",
    WebStringKey.ReasonCredentialKeywordsDesc to "L'URL contiene parole chiave per la raccolta di credenziali",
    // INFO
    WebStringKey.ReasonUnparseableTitle to "URL Non Analizzabile",
    WebStringKey.ReasonUnparseableDesc to "L'URL non può essere completamente analizzato",
    WebStringKey.ReasonAnalysisCompleteTitle to "Analisi Completata",
    WebStringKey.ReasonAnalysisCompleteDesc to "Analisi completata con successo",

    // ML Score Labels
    WebStringKey.MlPhishingScore to "Punteggio Phishing ML",
    WebStringKey.MlCharacterAnalysis to "Analisi caratteri",
    WebStringKey.MlFeatureAnalysis to "Analisi funzionalità",

    // Unicode Attack Breakdowns (Red Team scenarios)
    WebStringKey.IdnPunycodeDomainTitle to "Dominio IDN / Punycode",
    WebStringKey.IdnPunycodeDomainDesc to "Questo dominio utilizza caratteri internazionalizzati. Visualizzazione sicura:",
    WebStringKey.MixedScriptAttackTitle to "Attacco Script Misti",
    WebStringKey.MixedScriptAttackDesc to "Il dominio contiene caratteri da più script (es. Cirillico + Latino). Comune negli attacchi omografi.",
    WebStringKey.ConfusableCharsTitle to "Caratteri Confondibili",
    WebStringKey.ConfusableCharsDesc to "Il dominio contiene caratteri simili a lettere comuni (es. 'а' vs 'a')."
)

internal val ItalianCommonStrings = mapOf(
    "Engine Active" to "Motore Attivo",
    "Enterprise Protection Active" to "Protezione Aziendale Attiva",
    "Start New Scan" to "Avvia Nuova Scansione",
    "Import Image" to "Importa Immagine",
    "System Health" to "Stato del Sistema",
    "Threat Database" to "Database Minacce",
    "Current" to "Attuale",
    "Heuristic Engine" to "Motore Euristico",
    "Active" to "Attivo",
    "Threats" to "Minacce",
    "Safe Scans" to "Scansioni Sicure",
    "Recent Scans" to "Scansioni Recenti",
    "View Full History" to "Visualizza Cronologia Completa",
    "Status" to "Stato",
    "Source" to "Origine",
    "Details" to "Dettagli",
    "Time" to "Ora",
    "SAFE" to "SICURO",
    "SUSPICIOUS" to "SOSPETTO",
    "PHISHING" to "PHISHING",
    "UNKNOWN" to "SCONOSCIUTO",
    "Version" to "Versione",
    "Last Update" to "Ultimo Aggiornamento",
    "Signatures" to "Firme",
    "Check for Updates" to "Controlla Aggiornamenti",
    "Active Scanner" to "Scanner Attivo",
    "Offline Mode" to "Modalità Offline",
    "Camera Access Required" to "Accesso Fotocamera Richiesto",
    "Enable Camera" to "Abilita Fotocamera",
    "Scanning..." to "Scansione...",
    "Torch" to "Torcia",
    "Gallery" to "Galleria",
    "Paste URL" to "Incolla URL",
    "Analyze URL" to "Analizza URL",
    "Analyze" to "Analizza",
    "READY" to "PRONTO",
    "Local DB" to "DB Locale",
    "Latency" to "Latenza",
    "View All" to "Visualizza Tutto",
    "Dashboard" to "Dashboard",
    "Settings" to "Impostazioni",
    "Training Centre" to "Centro Formazione",
    "Beat the Bot" to "Batti il Bot",
    "Safe" to "Sicuro",
    "Suspicious" to "Sospetto",
    "Dangerous" to "Pericoloso",
    "Phishing" to "Phishing",
    "Legitimate" to "Legittimo",
    "Block & Report" to "Blocca e Segnala",
    "Copy Link" to "Copia Link",
    "Share" to "Condividi",
    "Export Report" to "Esporta Report",
    "Clear All" to "Cancella Tutto",
    "Cancel" to "Annulla",
    "Close" to "Chiudi",
    "Back to Dashboard" to "Torna alla Dashboard",
    "Scan Complete" to "Scansione Completata",
    "High Risk" to "Alto Rischio",
    "Low Risk" to "Basso Rischio",
    "Risk Score" to "Punteggio Rischio",
    "Confidence" to "Confidenza",
    "Homograph Attack" to "Attacco Omografo",
    "Detected" to "Rilevato",
    "Italiano" to "Italiano",
    
    // Result Screen Verdicts
    WebStringKey.VerdictSuspicious to "ATTIVITÀ SOSPETTA",
    WebStringKey.VerdictWarning to "Avviso",
    WebStringKey.VerdictSuspiciousDesc to "Il codice QR scansionato mostra pattern sospetti che possono indicare potenziali rischi per la sicurezza. Procedere con cautela.",
    WebStringKey.VerdictMinorConcerns to "PREOCCUPAZIONI MINORI",
    WebStringKey.VerdictCaution to "Cautela",
    WebStringKey.VerdictMinorConcernsDesc to "Sono state identificate alcune preoccupazioni di sicurezza minori. Il link sembra per lo più sicuro ma si consiglia una revisione.",
    WebStringKey.VerdictVerifiedSafe to "VERIFICATO SICURO",
    WebStringKey.VerdictSafeLabel to "Sicuro",
    WebStringKey.VerdictVerifiedSafeDesc to "Nessuna minaccia alla sicurezza rilevata. Il codice QR porta a una destinazione sicura verificata.",
    WebStringKey.VerdictNoActivity to "Nessuna Attività",
    WebStringKey.VerdictAwaitingScan to "In Attesa di Scansione",
    WebStringKey.VerdictNoActivityDesc to "Nessun dato di scansione disponibile. Scansiona un codice QR o inserisci un URL da analizzare.",
    WebStringKey.ScanQrToSeeActivity to "Scansiona un codice QR per vedere la tua attività qui",
    
    // Data Lifecycle Table
    WebStringKey.DataPoint to "Punto Dati",
    WebStringKey.ProcessingEnv to "Ambiente di Elaborazione",
    WebStringKey.ExternalTransmission to "Trasmissione Esterna",
    WebStringKey.RawImageBuffer to "Buffer Immagine Grezza",
    WebStringKey.LocalMemoryRam to "Memoria Locale (RAM)",
    WebStringKey.TransmissionNone to "Nessuna",
    WebStringKey.DecodedUrlPayload to "URL/Payload Decodificato",
    WebStringKey.LocalAnalysis to "Analisi Locale",
    WebStringKey.ThreatVerdictLabel to "Verdetto Minaccia",
    WebStringKey.LocalDatabase to "Database Locale"
)
